// Currency helpers shared by the cart, search, product form and bundle bar scripts.
//
// Prices coming from Liquid JSON and the Cart AJAX API are already in the active
// presentment currency, so they only ever need formatting. Conversion is needed
// solely for amounts hardcoded in EUR (the shop currency), and uses the rate
// Shopify injects rather than a rate table of our own.
window.CurrencyUtils = {
  // Formatting follows the currency's own conventions rather than the page
  // language, so JS-rendered prices match the `money` filter output they sit
  // next to. Unlisted currencies fall back to the page locale.
  currencyLocales: {
    EUR: 'nl-NL',
    GBP: 'en-GB',
    USD: 'en-US',
    CHF: 'de-CH',
    DKK: 'da-DK',
    NOK: 'nb-NO',
    SEK: 'sv-SE',
    PLN: 'pl-PL',
    RON: 'ro-RO',
    BGN: 'bg-BG',
  },

  getCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
  },

  getLocale(currency) {
    return this.currencyLocales[currency] || document.documentElement.lang || 'nl-NL';
  },

  /**
   * Rate from the shop currency to the active presentment currency.
   * @returns {number} Exchange rate, 1 when unavailable.
   */
  getExchangeRate() {
    const rate = Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
    return Number.isFinite(rate) && rate > 0 ? rate : 1;
  },

  /**
   * Convert an amount hardcoded in EUR to the active presentment currency.
   * Relies on EUR being the shop currency.
   * @param {number} amountInEUR - The amount in EUR cents.
   * @returns {number} The converted amount in cents.
   */
  convertFromEUR(amountInEUR) {
    const amount = Number(amountInEUR);
    if (!Number.isFinite(amount)) {
      return 0;
    }
    return Math.round(amount * this.getExchangeRate());
  },

  /**
   * Format a price in cents for display.
   * @param {number} cents - The price in cents.
   * @param {string} [currency] - Currency code, defaults to the active currency.
   * @returns {string} Formatted price string (e.g. '€7,20').
   */
  formatMoney(cents, currency = this.getCurrency()) {
    let safeCents = Number(cents);
    if (!Number.isFinite(safeCents)) {
      safeCents = 0;
    }
    const amount = safeCents / 100;
    const locale = this.getLocale(currency);

    let formatted;
    try {
      // narrowSymbol prefers 'kr' over 'SEK', but throws on Safari below 14.1.
      formatted = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        currencyDisplay: 'narrowSymbol',
      }).format(amount);
    } catch (error) {
      try {
        formatted = new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: currency,
        }).format(amount);
      } catch (fallbackError) {
        return amount.toFixed(2);
      }
    }

    // The `money` filter leaves no gap between a leading symbol and the amount,
    // so drop the separator Intl adds. Only applies to symbol prefixes: codes
    // like 'CHF 1’234.50' and suffixes like '1 234,50 kr' keep their spacing.
    return formatted.replace(/^([^\p{L}\p{N}\s]+)[\s\u00A0\u202F]+/u, '$1');
  },
};
